
import Component from 'vue-class-component';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { HelpCenterFAQEntry } from '@/help-center/types/help-center-faq-entry';
import { HelpCenterFIContactInfo } from '@/help-center/types/help-center-fi-contact-info';
import { UtilHelper } from '@/util/helper';
import { HelpCenterHelper } from '@/help-center/helper';

const helpCenterNamespace = namespace('helpCenter');

@Component
export default class HelpCenterFAQ extends Vue {
	@helpCenterNamespace.Getter('FAQtopics')
	public topics!: HelpCenterFAQEntry[];

	@helpCenterNamespace.Action('getFAQTopicQuestions')
	private getTopicQuestions!: (topic: HelpCenterFAQEntry) => HelpCenterFAQEntry[];

	@helpCenterNamespace.State('fiContactInfo')
	public fiContactInfo!: HelpCenterFIContactInfo;

	private activeTopic: HelpCenterFAQEntry | null = null;

	public activeQuestions: HelpCenterFAQEntry[] = [];

	public formatAnswer = HelpCenterHelper.formatFAQAnswer;

	public formatPhone = UtilHelper.formatPhoneNumber;

	get activeTopicId(): string {
		return this.activeTopic?.sys.id || '';
	}

	get activeTopicTitle(): string {
		return this.activeTopic?.fields.title || '';
	}

	get fiMailToHref(): string {
		return `mailto: ${this.fiContactInfo.email}`;
	}

	mounted(): void {
		this.setActiveTopic(this.topics[0]);
	}

	public goToQuestion(questionId: string): void {
		const [element] = this.$refs[questionId] as Element[];

		if (element) {
			element.scrollIntoView();
		}
	}

	public async setActiveTopic(topic: HelpCenterFAQEntry): Promise<void> {
		if (topic) {
			this.activeTopic = topic;
			this.activeQuestions = await this.getTopicQuestions(topic);
		}
	}
}

